import type { OutcomeTraceabilityView, QueryMetadata } from '@aurora-pvi/contracts';
import { apiFetch } from './apiFetch';

/**
 * Outcome traceability, from Postgres.
 *
 * This screen was the last one served entirely from fixtures — 2,855 lines of
 * authored TypeScript, while `core.outcome` held 426 rows nothing read. The
 * records live in `gov.*` now (migrations 0048 and 0049) and this repository
 * reads them, so the one screen arguing that every figure traces to a governed
 * record finally does.
 */

export interface OutcomeTraceabilityResult {
  data: OutcomeTraceabilityView;
  meta: QueryMetadata;
}

export function createHttpOutcomeRepository(baseUrl: string) {
  return {
    async getOutcomeTraceability(outcomeId?: string): Promise<OutcomeTraceabilityResult> {
      // Without an id the server chooses, and says which in `selectedOutcomeId`.
      const response = await apiFetch(
        outcomeId
          ? `${baseUrl}/outcomes/${encodeURIComponent(outcomeId)}/traceability`
          : `${baseUrl}/outcomes/traceability`,
      );
      if (!response.ok) {
        throw new Error('The outcome traceability record could not be loaded.');
      }
      return (await response.json()) as OutcomeTraceabilityResult;
    },
  };
}
